import type { LineItemI } from 'declarations/interfaces/lineItems';
import type { RepairOrderListI } from 'declarations/interfaces/RepairOrderList';
import type { RooftopExistsI } from 'declarations/interfaces/roofTopExists';

import { get, post } from './api';

export const getRepairOrderExistsApi = async (
  roofTopId: string,
  roNumber: string
): Promise<RooftopExistsI> => {
  const response = await get<RooftopExistsI>(`/repair-order/${roofTopId}/${roNumber}`);

  return response.data;
};

export const getLineItemsApi = async (
  roofTopId: string,
  roNumber: string
): Promise<LineItemI[]> => {
  const response = await get<LineItemI[]>(`/repair-order/${roofTopId}/${roNumber}/lineItems`);

  return response.data;
};

export const postRepairOderListApi = async (
  roofTopId: string,
  RepairOrderNumbers: string[]
): Promise<RepairOrderListI> => {
  const response = await post<RepairOrderListI>(
    `/integration/pull-repair-orders?RoofTopId=${roofTopId}&RepairOrderNumbers=${RepairOrderNumbers}`
  );
  return response.data;
};
